
import tables_title_en from './tables_title/tables_title_en'
import elementEnLocale from 'element-ui/lib/locale/lang/en'

import user_management_en from './user_management/user_management_en'
import role_management_en from './role_management/role_management_en'
import dept_management_en from './dept_management/dept_management_en'
import posts_management_en from './posts_management/posts_management_en'
import dict_management_en from './dict_management/dict_management_en'
import menu_management_en from './menu_management/menu_management_en'
import notice_management_en from './notice_management/notice_management_en'
import tenant_management_en from './tenant_management/tenant_management_en'

const en = {
  global:{
    home:'home',
    service_process:'service_process',
    grading_management:'grading management',
    accompanying:'accompanying',
    system:'system',
    wechat: 'wechat',
    users:'users',
    roles:'roles',
    depts:'depts',
    building: 'building',
    posts:'posts',
    dict_type:'dict type',
    menus:'menus',
    orders_management: 'orders management',
    appointment_management: 'appointment management',
    appointment_details: 'appointment details',
    contract_management: 'contract management',
    login_log:'login log',
    business_log:'business log',
    messages:'messages',
    tenants:'tenants',
    search:'search',
    add:'add',
    add_project:'add_project',
    add_patient: 'add_patient',
    back:'back',
    export:'export',
    expand_all:'expand all',
    clear_log:'clear log',
    modify:'edit',
    delete:'delete',
    details:'details',
    operation:'operation',
    submit:'submit',
    cancel:'cancel',
    logout:'logout',
    look: 'look',
    confirm:'confirm',
    change_password:'change password',
    old_password:'old password',
    new_password:'new password',
    empty_old_pwd:'Please enter your old password',
    empty_new_pwd:'Please enter your new password',
    modified_success:'Modified successfully',
    added_success:'Added successfully',
    del_success:'Delete succeeded',
    select_export:'Please select the data to export',
    table_data_title:'Data table',
    tips:'Tips',
    empty_sort:'Please enter sorting',
    patient_info: "patient_info",

    patient_management: 'patient management',
    edit: 'edit',
    reset: 'reset',
    edit_index: 'Edit the indicators',
    go_back: 'return',
    look_model_fill_in_ed: 'View the filled modules',
    edit_relevance_model: 'Edit correlation modules',
    look_relevance_model: 'Viewing the association Model',
    export_data: 'export data',
    statistic_analysis: 'statistic analysis',
    home_page: 'home page',
    write_astrict: 'Fill in the limit',
    verify_index_var: 'Check index variable',
    app_manage:'App management',
    order_details: 'order_details',
    accompaniment_order: "accompaniment order",
    copy:'Copy',
    patient_details: 'Patient details',
    personnel_details: 'Personnel details',
    accompanying_management: "accompanying management",
    accompanying_type_management: "accompanying type management",
    caregiver_post_management: "caregiver post management",
    accompanying_details: "accompanying details",
    accompanying_history: "accompanying history",
    grading_criteria: 'grading criteria',
    grading_gmanage: 'grading gmanage',
    company_management: 'company management',
    scale_management: 'scale management',
    certificate_management: 'certificate management',
    certificate_type_management: 'certificate_type_management',
    care_level_management: 'care level management',
    care_level_price_management: 'care level price management',
    care_level_detail_management: 'care level detail management',
    care_level_type_management: "care level type management",
    care_record_management: "care record management",
    workers_discount_management: "workers discount management",
    care_star_price_management: 'care star price management',
    class_type_management: 'class type management',
    class_group_management: 'class group management',
    class_scheduling_management: 'class scheduling management',
    banner_management: 'banner management',
    news_management: 'news management',
    complain_management: `complain_management`,
    company_reports: "company reports",
    // system_reports: "system reports",
    bed_management: "bed management",
    personnel_management:"personnel_management"
  },
  tables_title:tables_title_en,
  ...elementEnLocale,
  user_management:user_management_en,
  role_management:role_management_en,
  dept_management:dept_management_en,
  posts_management:posts_management_en,
  dict_management:dict_management_en,
  menu_management:menu_management_en,
  notice_management:notice_management_en,
  tenant_management:tenant_management_en
}


export default en



// WEBPACK FOOTER //
// ./src/common/lang/en.js